import { useCallback } from 'react';
import { useRouter } from 'next/navigation';

import { useNavigation } from '@/hooks/navigation/use-navigation.hook';
import { logoutUser } from '@/store/auth.store';

export const useLogout = () => {
  const router = useRouter();
  const { getHomeLink } = useNavigation();

  const handleLogout = useCallback(async () => {
    await logoutUser();
    router.push(getHomeLink());
  }, [getHomeLink, router]);

  return handleLogout;
};
